import { __ } from '@wordpress/i18n';
import { InspectorControls } from '@wordpress/block-editor';
import { SelectControl, PanelBody } from '@wordpress/components';

const STYLE_CLASS_OPTOPNS = [
	{
		label: 'なし',
		value: ''
	},
	{
		label: '背景: グレー',
		value: '-bg-gray'
	}
];

export const StyleInspector = ({children}) => {
	return (
		<InspectorControls>
			<PanelBody title={__('Style')}>
				{children}
			</PanelBody>
		</InspectorControls>
	);
};

export const SelectBgClassControl = ({value="",onChange}) => {
	return (
		<SelectControl
			label="ブロックの装飾スタイルを選択"
			value={value}
			options={STYLE_CLASS_OPTOPNS}
			onChange={onChange}
		/>
	);
};

import { LIST_STYLE_OPTIONS, isUlorOl } from './list-style';

export const SelectListStyleControl = ({value="none",onChange}) => {
	return (
		<SelectControl
			label="リストのマーカーのスタイルを選択"
			value={value}
			options={LIST_STYLE_OPTIONS}
			onChange={(val) => {
				onChange({marker:val,tag:isUlorOl(val)})
			}}
		/>
	);
};
